import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';

import VueParticles from 'vue-particles'
Vue.use(VueParticles)
Vue.use(ElementUI);


new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
